import { Component, EventEmitter, inject, isDevMode, OnDestroy, OnInit, Output } from '@angular/core';

import { NavLink } from '@classes/nav-link';
import { environment } from '@environments/environment';
import { AppConfigService } from '@services/app-config.service';
import { AuthService } from '@services/auth.service';
import { NavService } from '@services/nav.service';
import { ParameterService } from '@services/parameter.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-main-nav',
    templateUrl: './main-nav.component.html',
    styleUrls: ['./main-nav.component.scss'],
    standalone: false
})
export class MainNavComponent implements OnInit, OnDestroy {
    @Output() sidenavClose = new EventEmitter<void>();

    navLinks: NavLink[];
    isMaintenance: boolean;
    isLocalTranslations: boolean = isDevMode();
    appVersion: string;

    private readonly unsubscribeAll = new Subject<void>();

    private readonly parameterSrv = inject(ParameterService);
    private readonly navSrv = inject(NavService);
    private readonly authSrv = inject(AuthService);
    private readonly configSrv = inject(AppConfigService);

    ngOnInit() {
        this.appVersion = environment.version;
        this.isMaintenance = this.configSrv.isMaintenance;

        this.initSubscriptions();
    }

    ngOnDestroy(): void {
        this.unsubscribeAll.next();
        this.unsubscribeAll.complete();
    }

    onCloseSidenav(): void {
        this.sidenavClose.emit();
    }

    private initSubscriptions() {
        this.authSrv.authUser$
            .pipe(takeUntil(this.unsubscribeAll))
            .subscribe((user) => {
                if (user) {
                    this.parameterSrv.getReportMode().subscribe(reportMode => {
                        this.navLinks = this.navSrv.getNavLinks();
                    });
                } else {
                    this.navLinks = this.navSrv.getNavLinks();
                }
                
            });
    }
}
